<span *ngIf="country?.iso" class="fi fis fi-{{ country.iso|lowercase }}" title="{{ country.name }}"></span>